import { language } from "@chef/constants";

export const intl = (
  {
    dk: {
      CHANGE_ADDRESS: "Skift aktiv adresse",
      SELECT_ADDRESS_AND_TIME: "Vælg adresse og tidspunkt",
      FORM_DESCRIPTION:
        "Her kan du vælge hvilken adresse du vil ha din måltidskasse leveret på. Du kan også justere både tidspunkt og hvor ofte du får levering.",

      ADDRESS: "Adresse",
      WHEN_TO_DELIVER: "Hvornår leverer vi",
      HOW_OFTEN_TO_DELIVER: "Hvor ofte skal vi levere",

      SAVE_CHANGES: "Gem ændring",
      CANCEL: "Annuller",

      ERROR_UPDATING_ADDRESS: "Der skete en fejl ved opdatering af din adresse",

      NO_DELIVERY_WARNING:
        "Vi leverer desværre ikke længere til denne adresse. Hvis du har spørgsmål, bedes du kontakte kundeservice.",
    },

    se: {
      CHANGE_ADDRESS: "Ändra aktiv adress",
      SELECT_ADDRESS_AND_TIME: "Välj adress och leveranstid",
      FORM_DESCRIPTION:
        "Välja vilken adress du vill ha din matkasse levererad till. Du kan också justera både leveranstid och leveransintervall.",

      ADDRESS: "Adress",
      WHEN_TO_DELIVER: "När ska vi leverera",
      HOW_OFTEN_TO_DELIVER: "Hur ofta ska vi leverera",

      SAVE_CHANGES: "Spara ändring",
      CANCEL: "Avbryt",

      ERROR_UPDATING_ADDRESS:
        "Något gick fel när vi skulle uppdatera din adress",

      NO_DELIVERY_WARNING:
        "Vi har tyvärr slutat leverera till denna adress. Om du har några frågor, vänligen kontakta kundtjänst.",
    },
    no: {
      CHANGE_ADDRESS: "Bytt aktiv adresse",
      SELECT_ADDRESS_AND_TIME: "Velg adresse og tidspunkt",
      FORM_DESCRIPTION:
        "Her kan du velge hvilken adresse du vil ha din matkasse levert på. Du kan også justere både tidspunkt og hvor ofte du får levering.",
      ADDRESS: "Adresse",
      WHEN_TO_DELIVER: "Når leverer vi",
      HOW_OFTEN_TO_DELIVER: "Hvor ofte skal vi levere",
      SAVE_CHANGES: "Lagre endring",
      CANCEL: "Avbryt",
      SUCCESS_UPDATING_ADDRESS: "Din adresse ble oppdatert",
      ERROR_UPDATING_ADDRESS:
        "Det skjedde en feil ved opdatering av din adresse",
      NO_DELIVERY_WARNING:
        "Vi leverer dessverre ikke lenger til denne adressen. Hvis du har spørsmål, kan du kontakte kundeservice.",
    },
  } as const
)[language];
